import { Award } from "lucide-react";

/**
 * LevelSeal — selo metálico elegante (bronze, prata, ouro)
 * Sem aparência infantil/gamer; institucional e premium.
 */
export function LevelSeal({ seal, size = 40, withRing = true, className = "" }) {
  if (!seal) return null;
  const palette = {
    bronze: {
      ring: "ring-[#9c5b2c]/60",
      bg: "linear-gradient(135deg, #b87333 0%, #8b4513 50%, #cd7f32 100%)",
      shadow: "0 2px 6px rgba(139,69,19,0.45), inset 0 1px 0 rgba(255,255,255,0.25)",
      text: "#fff8ec",
      label: "BRONZE",
    },
    prata: {
      ring: "ring-[#9aa4b1]/60",
      bg: "linear-gradient(135deg, #c0c5cc 0%, #6b7280 50%, #a8b0bb 100%)",
      shadow: "0 2px 6px rgba(75,85,99,0.45), inset 0 1px 0 rgba(255,255,255,0.45)",
      text: "#0f172a",
      label: "PRATA",
    },
    ouro: {
      ring: "ring-[#b88a2d]/70",
      bg: "linear-gradient(135deg, #e9c66f 0%, #c9a961 45%, #f1d68b 100%)",
      shadow: "0 3px 10px rgba(201,169,97,0.55), inset 0 1px 0 rgba(255,255,255,0.55)",
      text: "#3a2a07",
      label: "OURO",
    },
  };
  const p = palette[seal] || palette.bronze;
  return (
    <div
      role="img"
      aria-label={`Selo ${p.label}`}
      data-testid={`level-seal-${seal}`}
      className={`inline-flex items-center justify-center rounded-full ${withRing ? "ring-1 " + p.ring : ""} ${className}`}
      style={{
        width: size,
        height: size,
        background: p.bg,
        boxShadow: p.shadow,
      }}
    >
      <Award className="opacity-90" style={{ color: p.text, width: size * 0.5, height: size * 0.5 }} />
    </div>
  );
}

export function LevelSealLabel({ seal, level }) {
  if (!seal) {
    return (
      <span className="text-[11px] uppercase tracking-wider text-white/70">{level || "Aluno CEAP"}</span>
    );
  }
  const colorByLevel = {
    bronze: "border-[#cd7f32]/60 bg-[#cd7f32]/15 text-[#fde7c8]",
    prata: "border-[#cbd5e1]/55 bg-white/15 text-white",
    ouro: "border-[hsl(var(--gold)/0.55)] bg-[hsl(var(--gold)/0.20)] text-white",
  }[seal];
  return (
    <span className={`px-2.5 py-0.5 rounded-full border text-[10px] tracking-wider uppercase font-medium ${colorByLevel}`}>
      {level || seal.toUpperCase()}
    </span>
  );
}
